var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNetworkNormal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 2C13.3358 2 13 2.33579 13 2.75V13.25C13 13.6642 13.3358 14 13.75 14H14.25C14.6642 14 15 13.6642 15 13.25V2.75C15 2.33579 14.6642 2 14.25 2H13.75ZM9.75 4C9.33579 4 9 4.33579 9 4.75V13.25C9 13.6642 9.33579 14 9.75 14H10.25C10.6642 14 11 13.6642 11 13.25V4.75C11 4.33579 10.6642 4 10.25 4H9.75ZM5.75 7C5.33579 7 5 7.33579 5 7.75V13.25C5 13.6642 5.33579 14 5.75 14H6.25C6.66421 14 7 13.6642 7 13.25V7.75C7 7.33579 6.66421 7 6.25 7H5.75ZM1 10.75C1 10.3358 1.33579 10 1.75 10H2.25C2.66421 10 3 10.3358 3 10.75V13.25C3 13.6642 2.66421 14 2.25 14H1.75C1.33579 14 1 13.6642 1 13.25V10.75Z",
    fill: "#FEDD0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetworkNormal);
export default __webpack_public_path__ + "static/media/icon-network-normal.c7501eb466acb5de131256331372e620.svg";
export { ForwardRef as ReactComponent };